export default __webpack_public_path__ + "static/media/personDetail.c866d082.webp";